const quiz = {
  'both': [
    {
      'Question': 'Pohlavie',
      'Answers': [
        {key: 'woman', answer: 'Žena'},
        {key: 'man', answer: 'Muž'}
      ],
      'key': 'gender'
    }
  ],
  'woman': [
    {
      'Question': 'Ktorému trendu v oblasti starostlivosti o krásu si podľahla?',
      'Answers': [
        {key: '1', answer: 'Napichané pery'},
        {key: '2', answer: 'Drepy, drepy, drepy'},
        {key: '3', answer: 'Pečivo a sladké?! To je čo?'},
        {key: '4', answer: 'Milujem svoje nové prsia'},
        {key: '5', answer: 'Bez pohára čistej vody ani na krok!'}
      ],
      'key': ''
    },
    {
      'Question': 'Čo urobíš každý deň aspoň raz?',
      'Answers': [
        {key: '1', answer: 'Vypijem si kávičku'},
        {key: '2', answer: 'Pobozkám frajera'},
        {key: '4', answer: 'Vojdem medzizubkou do každého priestoru medzi zubami'},
        {key: '5', answer: 'Dám lajk na fotku niektorej z kamošiek'},
        {key: '3', answer: 'Vytočím frajera'}
      ],
      'key': ''
    },
    {
      'Question': 'Ako by si opísala svoj úsmev?',
      'Answers': [
        {key: '1', answer: 'Žiariace hviezdičky'},
        {key: '2', answer: '50 odtieňov žltej'},
        {key: '4', answer: 'Noty na bubon'},
        {key: '6', answer: 'Neopísateľný!'},
        {key: '3', answer: 'V zdravom tele zdravý chrup!'},
        {key: '5', answer: 'Zbraň hromadného ničenia'}
      ],
      'key': ''
    },
    {
      'Question': 'Ktoré ovocie je tvoje naj?',
      'Answers': [
        {key: 'green', answer: 'Jablko'},
        {key: 'orange', answer: 'Marhuľa'},
        {key: 'blue-light', answer: 'Černica'},
        {key: 'yellow', answer: 'Grapefruit'},
        {key: 'pink-light', answer: 'Leto bez červeného melóna nie je leto'},
        {key: 'pink', answer: 'Načo ovocie, radšej gin-tonic'}
      ],
      'key': ''
    },
    {
      'Question': 'V ktorom prostredí sa cítiš najlepšie?',
      'Answers': [
        {key: 'environment-1', answer: 'Vymetať nákupné centrá, na to by ma bolo'},
        {key: 'environment-2', answer: 'Kaviarnička s poličkami vyplnenými starými knihami'},
        {key: 'environment-6', answer: 'Zavretá doma, kde nikto nevidí, že jem už tretiu čokoládu'},
        {key: 'environment-4', answer: 'Ruka hore s kamoškami v nočnom podniku'},
        {key: 'environment-3', answer: 'Niet nad deň v prírode!'},
        {key: 'environment-5', answer: 'Na bežiacom páse vo fitku'}
      ],
      'key': ''
    }
  ],
  'man': [
    {
      'Question': 'Ako by si opísal svoj úsmev?',
      'Answers': [
        {key: '6', answer: 'Neopísateľný!'},
        {key: '1', answer: 'Magnet na ženy'},
        {key: '4', answer: 'Noty na bubon'},
        {key: '3', answer: 'V zdravom tele zdravý chrup!'},
        {key: '5', answer: 'Darovanému koňovi na zuby nepozeraj'},
        {key: '2', answer: 'Pri mojej hipsterskej brade ho ani nevidno'}
      ],
      'key': ''
    },
    {
      'Question': 'Na aký film by si išiel do kina?',
      'Answers': [
        {key: '1', answer: 'Akčný, nech to duní a strieľa na všetky strany'},
        {key: '2', answer: 'Horor, aby sa vystrašená frajerka túlila'},
        {key: '3', answer: 'Komédia, však život je sám o sebe dosť vážny'},
        {key: '4', answer: 'Romantický, aby si aj frajerka prišla na svoje'},
        {key: '5', answer: 'Dobrodružný, nech aspoň vidím, čo sám nikdy nezažijem'}
      ],
      'key': ''
    },
    {
      'Question': 'Aký je tvoj obľúbený šport?',
      'Answers': [
        {key: '1', answer: 'Skok do postele'},
        {key: '2', answer: 'Behanie za babami'},
        {key: '3', answer: 'Maratón s prstami po kúpe najnovšieho smartfónu'},
        {key: '5', answer: 'Preteky s časom, keď robím niečo na poslednú chvíľu'},
        {key: '4', answer: 'Hoď to do seba!'}
      ],
      'key': ''
    },
    {
      'Question': 'Ktoré ovocie je tvoje naj?',
      'Answers': [
        {key: 'green', answer: 'Jablko'},
        {key: 'orange', answer: 'Marhuľa'},
        {key: 'yellow', answer: 'Grapefruit'},
        {key: 'blue-light', answer: 'Černica'},
        {key: 'pink-light', answer: 'Leto bez červeného melóna nie je leto'},
        {key: 'pink', answer: 'Načo ovocie, radšej gin-tonic'}
      ],
      'key': ''
    },
    {
      'Question': 'V ktorom prostredí sa cítiš najlepšie?',
      'Answers': [
        {key: 'environment-1', answer: 'Uprostred burácajúceho davu fanúšikov na štadióne'},
        {key: 'environment-2', answer: 'Kaviarnička s poličkami vyplnenými starými knihami'},
        {key: 'environment-6', answer: 'Behajúc v parku hádzať očkom na bežkyne'},
        {key: 'environment-3', answer: 'Ja a môj gauč = láska na celý život'},
        {key: 'environment-4', answer: 'Niet nad deň v prírode!'},
        {key: 'environment-5', answer: 'V krčme medzi svojimi'}
      ],
      'key': ''
    }
  ],
  'results': {
    'colors': {
      'woman': {
        'green': 'Rada <strong>objavuješ nové miesta</strong>, veci aj pocity',
        'orange': '<strong>Radosť zo života</strong>, to je tvoje',
        'pink-light': 'Svojim <strong>chuťovým bunkám rada dopraješ</strong>',
        'yellow': 'Keď je treba, <strong>vieš zahviezdiť</strong>',
        'blue-light': 'Rada sa <strong>zasnívaš aj s otvorenými očami</strong>',
        'pink': 'Si <strong>pripravená na každú výzvu</strong>'
      },
      'man': {
        'green': 'Rád <strong>objavuješ nové miesta</strong>, veci aj pocity',
        'orange': '<strong>Radosť zo života</strong>, to je tvoje',
        'pink-light': 'Svojim <strong>chuťovým bunkám rád dopraješ</strong>',
        'yellow': 'Keď je treba, <strong>vieš zahviezdiť</strong>',
        'blue-light': 'Rád sa <strong>zasnívaš aj s otvorenými očami</strong>',
        'pink': 'Si <strong>pripravený na každú výzvu</strong>'
      },
      'both': {
        'green': 'Rád/a <strong>objavuješ nové miesta</strong>, veci aj pocity',
        'orange': '<strong>Radosť zo života</strong>, to je tvoje',
        'pink-light': 'Svojim <strong>chuťovým bunkám rád/a dopraješ</strong>',
        'yellow': 'Keď je treba, <strong>vieš zahviezdiť</strong>',
        'blue-light': 'Rád/a <strong>sa zasnívaš aj s otvorenými očami</strong>',
        'pink': 'Si <strong>pripravený/á na každú výzvu</strong>'
      }
    },
    'environment': {
      'woman': {
        'environment-1': 'a si pravá fashion maniačka.',
        'environment-2': 'a vieš si vychutnať kávičku a rozhovory v štýlovom prostredí.',
        'environment-3': 'a miluješ kombináciu čerstvého vzduchu a krásnych výhľadov.',
        'environment-4': 'a zábava s kamoškami je tvojou obľúbenou závislosťou.',
        'environment-5': 'a na svojej forme poctivo makáš.',
        'environment-6': 'a rada si sama so sebou dopraješ svoje úlety.'
      },
      'man': {
        'environment-1': 'a rád sa ocitáš vo víre diania.',
        'environment-2': 'a vieš si vychutnať kávu a či rozhovory v štýlovom prostredí.',
        'environment-3': 'a miluješ obývačkovú pohodu pri filme či futbale.',
        'environment-4': 'a miluješ kombináciu čerstvého vzduchu a krásnych výhľadov.',
        'environment-5': 'a kamoši a pivo je tvoja srdcová kombinácia.',
        'environment-6': 'a pneumatike okolo pása nedávaš šancu.'
      }
    },
    'paste': {
      'green': 'Poď dnes do pasty s príchuťou <strong>jablko a aloe vera</strong> a vychutnaj si túto dobrodružnú kombináciu.',
      'orange': 'Poď dnes do pasty, ktorej chuť tvorí optimistická dvojka <strong>broskyňa-marhuľa</strong> a uži si deň s úsmevom.',
      'pink-light': 'Poď dnes do pasty s príchuťou <strong>červeného melóna</strong> a zamaškrť si aj pri čistení zubov.',
      'yellow': 'Poď dnes do pasty s príchuťou <strong>grapefruitu a bergamotu</strong> a zažiar naplno.',
      'blue-light': 'Poď dnes do pasty s príchuťou <strong>černice a sladkého drievka</strong> a nechaj deň plynúť pomaly.',
      'pink': 'Poď dnes do pasty s príchuťou <strong>hurmikaki a gin-tonic</strong>, ktorá ťa nakopne.'
    }
  },
  'pasteUrl': {
    'green': 'https://shop.curaprox.sk/produkty/243-zubna-pasta-be-you-explorer.html',
    'orange': 'https://shop.curaprox.sk/produkty/241-zubna-pasta-be-you-pure-happiness.html',
    'pink-light': 'https://shop.curaprox.sk/produkty/242-zubna-pasta-be-you-candy-lover.html',
    'yellow': 'https://shop.curaprox.sk/produkty/244-zubna-pasta-be-you-rising-star.html',
    'blue-light': 'https://shop.curaprox.sk/produkty/240-zubna-pasta-be-you-daydreamer.html',
    'pink': 'https://shop.curaprox.sk/produkty/239-zubna-pasta-be-you-challenger.html'
  }
}

export default quiz



// WEBPACK FOOTER //
// ./src/components/quiz.js